export default "__VITE_ASSET__Zmaos6$a__"